<template>
    <transition name="modal-fade">
        <div class="modal-backdrop" v-bind:class="className">
            <div class="modal-overlay" @click="back()"></div>
            <div class="modal">
                <article v-if="resource">

                    <header>
                        <figure>
                          <img :src="$iconFolder + 'commercial-gesture.svg'"/>
                        </figure>
                        <div>
                            <span class="breadcrumb">
                                Commercial Gesture <i class="icon icon-icon_arrow-right"></i> Edit
                            </span>
                            <h1>{{ resource.name ? resource.name : 'Nouveau' }}</h1>
                        </div>
                        <div class="spacer"></div>
                        <div class="buttons">
                            <button @click="back()" class="bt-back"><span><i class="icon icon-icon_close"></i></span></button>
                            <button @click="submit()" class="bt-primary bt-save"><span><i class="icon icon-icon_tick"></i></span></button>
                        </div>
                    </header>

                    <main>

                        <languages :localesLoaded="localesLoaded" :locales="locales" v-model="locale" :translations="resource.translations"></languages>

                        <tabs :options="{ useUrlFragment: false }">
                            <tab name="Information">

                              <fieldset>
                                <h3>Détail</h3>
                                <p class="headline"></p>

                                <form-scopes label='Scopes' v-model="resource"></form-scopes>
                                <form-text :label="'Identifiant unique'" v-model="resource.internal_identifier" :required="true"></form-text>
                                <form-text  :label="'Nom'" v-model="resource.name" :required="true"></form-text>

                              </fieldset>

                            </tab>
                            <tab name="Conditions de vente">

                              <fieldset>
                                <h3>Conditions de vente</h3>
                                <p class="headline"></p>

                                <button @click="addCondition">Ajouter une condition</button>
                                <div v-for="(item, index) in resource.discounts">

                                    <div>
                                        <form-text  :label="'Nom'" v-model="item.name"></form-text>
                                        <form-text label="Valeur" v-model="item.value" suffix="%"></form-text>
                                        <component-conditions v-model="item.conditions" :options="options"></component-conditions>
                                      <button @click="removeCondition(index)">Supprimer</button>
                                    </div>

                                </div>

                              </fieldset>

                            </tab>
                        </tabs>

                    </main>
                </article>

            </div>
        </div>
    </transition>
</template>
<script>

    import CommercialGestureService from './CommercialGestureService.js';
    import Edit from '../../../layouts/Edit.vue';

    import ComponentConditions from "../../../components/Conditions.vue";

    export default {
        extends: Edit,
        components: {
          'component-conditions': ComponentConditions
        },
        data () {
            return {
              options: [],
              options_default: [
                {
                  id:"product.brand_id",
                  name: "Marque",
                  options: null,
                  operators:[
                    {id:'egal', name:'='},
                    {id:'greater_than', name:'>'},
                    {id:'egal_greater_than', name:'>='},
                    {id:'less_than', name:'<'},
                    {id:'egal_less_than', name:'<='},
                    {id:'not_egal', name:'!='},
                    {id:'in', name:'in (..., ...)'},
                    {id:'contain', name:'contains'},
                    {id:'is_null', name:'is empty'},
                    {id:'is_not_null', name:'is not empty'}
                  ]
                },{
                  id:"product.sku",
                  name: "SKU du produit",
                  options: null,
                  operators:[
                    {id:'egal', name:'='},
                    {id:'greater_than', name:'>'},
                    {id:'egal_greater_than', name:'>='},
                    {id:'less_than', name:'<'},
                    {id:'egal_less_than', name:'<='},
                    {id:'not_egal', name:'!='},
                    {id:'in', name:'in (..., ...)'},
                    {id:'contain', name:'contains'},
                    {id:'is_null', name:'is empty'},
                    {id:'is_not_null', name:'is not empty'}
                  ]
                },{
                  id:"product.category_id",
                  name: "Catégorie",
                  options: null,
                  operators:[
                    {id:'egal', name:'='},
                    {id:'greater_than', name:'>'},
                    {id:'egal_greater_than', name:'>='},
                    {id:'less_than', name:'<'},
                    {id:'egal_less_than', name:'<='},
                    {id:'not_egal', name:'!='},
                    {id:'in', name:'in (..., ...)'},
                    {id:'contain', name:'contains'},
                    {id:'is_null', name:'is empty'},
                    {id:'is_not_null', name:'is not empty'}
                  ]
                }
              ]
            }
        },
        mounted: function(){

        },
        methods:{
            resourceLoaded: function(){

                this.resource.discounts = this.resource.discounts ? this.resource.discounts : [];

                this.options = this.options_default
                if( this.resource.attributes ){
                  for(let item of this.resource.attributes){
                    this.options.push({
                      id: 'attributable.' + item.attribute_id,
                      name: item.name
                    })
                  }
                }

                this.initialize()
            },
            getResource: function(){
                return CommercialGestureService
            },
            beforeUpdate: function(Resource){
                return true;
            },
            addCondition: function()
            {
              this.resource.discounts.push({
                    id: null,
                    name: null,
                    value: 0,
                    conditions: []
                });
              this.$forceUpdate();
            },
            removeCondition: function(index)
            {
                let action = confirm("Etes-vous sûr de vouloir supprimer cette condition ?");
                if( action ){
                  this.resource.discounts.splice(index, 1);
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/shop/commercial-gesture/Edit.vue